require('./hireCardPremiumPackView.scss');

// @vendors
const PropTypes = require('prop-types');
const React = require('react');
const { withRouter } = require('react-router-dom');
const { connect } = require('react-redux');

// @helpers
const { formatText, getFinalTitle } = require('core/i18n').i18n;
const { ownerFromAccount } = require('utilities/contactCenter/cardHireHelper');
const { getCollectiveTagDetails } = require('utilities/collectivesHelper');
const { isAvailableHireCreditCards } = require('utilities/cardsHelper');

// @actions
const blockedAccountsAction = require('actions/blockedAccounts');
const hireCardPremiumPackActions = require('actions/hireCardPremiumPack');
const hireCreditLimitActions = require('actions/hireCreditLimit');
const mergePreContractualsPDF = require('actions/mergePreContractualsPDF');
const preContractualMailActions = require('actions/contactCenter/preContractualMailInfo/preContractualMailInfo');
const precontractualDocumentMailAction = require('actions/precontractualDocumentsMailer');
const shippingAddressAction = require('actions/shippingAddress');
const termsAndCondsInfoActions = require('actions/termsAndCondsInfo');
const hireCardCreditINEActions = require('actions/commons/hireCardCreditINE');
const printedActions = require("actions/contactCenter/printer");
const mortgageRequestHolderConfirmation = require("actions/mortgageRequest/mortgageRequestHolderConfirmation");

// @commons
const Wizard = require('components/commons/wizard/wizard');
const WizardStep = require('components/commons/wizardStep/wizardStep');
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { OKCover } = require('commonsComponents/OKCover');

// @components
const HireCardPremiumPackStep1 = require('components/hire/cardPremiumPack/hireCardPremiumPackStep1/hireCardPremiumPackStep1');
const HireCardPremiumPackStep2 = require('components/hire/cardPremiumPack/hireCardPremiumPackStep2/hireCardPremiumPackStep2');
const HireCardPremiumPackStep3 = require('components/hire/cardPremiumPack/hireCardPremiumPackStep3/hireCardPremiumPackStep3');
const HireCardPremiumPackStep4 = require('components/hire/cardPremiumPack/hireCardPremiumPackStep4/hireCardPremiumPackStep4');
const HireCardPremiumPackStep5 = require('components/hire/cardPremiumPack/hireCardPremiumPackStep5/hireCardPremiumPackStep5');
const HireCardPremiumPackSuccess = require('components/hire/cardPremiumPack/hireCardPremiumPackSuccess/hireCardPremiumPackSuccess');
const HireCarPremiumPackError = require('components/hire/cardPremiumPack/hireCardPremiumPackError/hireCardPremiumPackError');
const HireCardSidebar = require('components/hire/hireCardSidebar/hireCardSidebar');
const HireCardOpenCreditStepINE = require('components/hire/cardINEDocument/hireCardOpenCreditStepINE');
const WebappRender = require('components/conditionalRender/webappRender');
const ContactCenterRender = require('components/conditionalRender/contactCenterRender');
const { CallMeBack } = require('components/callMeBack/callMeBack');
const { isPrintOfficeMode } = require('utilities/contactCenter/printerHelper');

// @constants
const { WIZARD_FIRST_STEP,
    REDIRECT_URL,
    THIRD_STEP,
    CREDIT_CARD_TYPE_PACK,
    CREDIT_CARD_SUBTYPE_PREMIUM,
    DEBIT_CARD_TYPE,
    DEBIT_CARD_SUBTYPE_PREMIUM,
    PREMIUM_PACK_STANDARD,
    PREMIUM_PACK_HIRING,
    WIZARD_SECOND_STEP
} = require('constants/index');
const { HIRE_CARD_PREMIUM_PACK } = require('constants/operationCodesAccounts');
const EXTRA_IMAGE = 'B.506.009.003';
const { PREMIUM_PACK_PRODUCT_ALIAS } = require('constants/hiringProductInformation');
const {
    WEB_INACTIVE_ACCOUNT_ENABLED,
    CREDIT_CARD_REVOLVING_PROCESS,
    LIMIT_CREDIT_CARD,
    ES_COUNTRY,
    MESSAGE_HIRE_24H,
    NOT_ALLOWED_NEW_CREDIT_CARDS_FLOW_COUNTRIES,
} = require('constants/flagBasedFeatures');
const { catalogue, analyticsId } = require('../../components/hire/cardPremiumPack/analytics/hireCardPremiumPackAnalytics');

class HireCardPremiumPackView extends React.Component {
    constructor(props) {
        super(props);
        this.isReady = this.isReady.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
    }

    componentDidMount() {
        const {
            getshippingAddressList,
            getBlockedAccounts,
            immAccounts,
            match: { params: { redirect } },
            validateStep,
            resetPrecontractualDocumentMail,
            immFlagBasedFeatures,
            reset,
            resetBlockedAccounts,
            resetPrecontractualMail,
            resetTermsAndCondsText,
        } = this.props;
        const newCardsFF = immFlagBasedFeatures.get(NOT_ALLOWED_NEW_CREDIT_CARDS_FLOW_COUNTRIES);
        if (newCardsFF) {
            reset();
            resetBlockedAccounts();
            resetTermsAndCondsText();
            if (__CONTACT_CENTER__) resetPrecontractualMail()

        }
        resetPrecontractualDocumentMail();
        if (redirect === REDIRECT_URL) {
            validateStep(WIZARD_FIRST_STEP);
        }
        getBlockedAccounts(immAccounts.get('byId').toList(), HIRE_CARD_PREMIUM_PACK);
        getshippingAddressList();
    }

    componentWillUnmount() {
        const {
            reset,
            resetBlockedAccounts,
            resetPrecontractualMail,
            resetTermsAndCondsText,
        } = this.props

        reset();
        resetBlockedAccounts();
        resetTermsAndCondsText();

        if (__CONTACT_CENTER__) resetPrecontractualMail()
    }

    getProcessDetail() {
        return `${CREDIT_CARD_TYPE_PACK}.${CREDIT_CARD_SUBTYPE_PREMIUM} - ${DEBIT_CARD_TYPE}.${DEBIT_CARD_SUBTYPE_PREMIUM}`;
    }

    handleCancel() {
        this.props.history.push('/myprofile/cards');
    }
    
    buildINE() {
        const { hireCardOpenCreditprintDocument, immHireCardPremiumPack, cardsConfimationScrollDown, checkCheckedDocument, printedAndSignedRadioChanged, enableButtonOffice, checkRadioButton, immPrinter, hireCardPremiumPackPrintDocument } = this.props;
        const documentINE = immHireCardPremiumPack.get('documentINE')
        const scrollDown = immHireCardPremiumPack.get('scrollDown')
        const agreeIneCheckbox = immHireCardPremiumPack.get('agreeIneCheckbox')
        const checkButtonRadio = immHireCardPremiumPack.get('checkButtonRadio')
        const printDocument = immHireCardPremiumPack.get('printDocument')
        const documentsPrintedAndSigned = immHireCardPremiumPack.get('cardsDocumentsPrintedAndSigned')

        return (
            <HireCardOpenCreditStepINE
                documentINE={documentINE}
                cardsConfimationScrollDown={cardsConfimationScrollDown}
                scrollDown={scrollDown}
                checkCheckedDocument={checkCheckedDocument}
                agreeIneCheckbox={agreeIneCheckbox}
                printedAndSignedRadioChanged={printedAndSignedRadioChanged}
                enableButtonOffice={enableButtonOffice}
                checkRadioButton={checkRadioButton}
                checkButtonRadio={checkButtonRadio}
                hireCardPremiumPackprintDocument={hireCardPremiumPackPrintDocument}
                printDocument={printDocument}
                immPrinter={immPrinter}
                documentsPrintedAndSigned={documentsPrintedAndSigned}
                hireCardOpenCreditprintDocument={hireCardOpenCreditprintDocument}
        />
        );
    }

    isReady() { // it warns the user if he's about to lose changes
        const { immHireCardPremiumPack } = this.props;
        let showPreLeaveModal = true;

        if (immHireCardPremiumPack.get('visibleStep') === 1) {
            showPreLeaveModal = false;
        }

        return showPreLeaveModal;
    }

    buildSuccessful() {
        const {
            immAccounts,
            immCollectivesCardContent,
            immHireCardImageSelector,
            immHireCardNameSelector,
            immHireCardPremiumPack,
            immHireCreditLimit,
            immHirePaymentMethod,
            immProfile,
            immShippingAddressList
        } = this.props;
        const selectedAccount = immHireCardPremiumPack.getIn(['steps', THIRD_STEP, 'accountId']);
        const immAccount = immAccounts.getIn(['byId', selectedAccount]);

        const processDetail = this.getProcessDetail();

        return (
            <div className="col-xs-12 col-md-offset-1 col-md-10">
                <HireCardPremiumPackSuccess
                    extraImage={EXTRA_IMAGE}
                    immAccount={immAccount}
                    immCollectivesCardContent={immCollectivesCardContent}
                    immHireCardPremiumPack={immHireCardPremiumPack}
                    immHireCardImageSelector={immHireCardImageSelector}
                    immHireCardNameSelector={immHireCardNameSelector}
                    immHireCreditLimit={immHireCreditLimit}
                    immHirePaymentMethod={immHirePaymentMethod}
                    immProfile={immProfile}
                    immShippingAddress={immShippingAddressList.get('shippingAddress')}
                    processDetail={processDetail}
                />
            </div>
        );
    }

    buildWizardHiringSteps() {
        const {
            handleAccountChange,
            handleAgreementCheckboxChange,
            hireCardPremiumPack,
            immAccounts,
            immFlagBasedFeatures,
            immCollectivesCardContent,
            immGlobalVariables,
            immHireCardImageSelector,
            immHireCardNameSelector,
            immHireCardPremiumPack,
            immHireContactData,
            immHireCreditLimit,
            immHireInformation,
            immHirePaymentMethod,
            immHiringProductBanners,
            immPdfData,
            immProfile,
            immShippingAddressList,
            immTopbar,
            requestPDFMerge,
            sendPrecontractualDocumentMail,
            setAllAccountsToInactive,
            setHireCreditLimit,
            setShippingAddress,
            setTermsAndCondsText,
            setVisibleStep,
            setWillCancel,
            toggleCreditLimitModal,
            validateStep,
            validate,
            immRevolvingPersistentData,
            onHandleChangeCheckBoxCC,
            myCardsTarjetasHire,
            hireCardPremiumPackprintDocument,
            cardsConfimationScrollDownPolicy,
            hireCardPremiumPackprintDocumentPolicy,
            printedAndSignedRadioChanged,
            enableButtonOffice,
            checkRadioButtonPolicy,
            getInitCardsDocuments,
            processEmail
        } = this.props;

        const documentsPrintedAndSigned = immHireCardPremiumPack.get('cardsDocumentsPrintedAndSigned');
        const newCardsFF = immFlagBasedFeatures.get(NOT_ALLOWED_NEW_CREDIT_CARDS_FLOW_COUNTRIES);

        const wizardActions = {
            cancel: this.handleCancel,
            finish: newCardsFF ? myCardsTarjetasHire : hireCardPremiumPack,
            setVisibleStep,
            setWillCancel,
            validateStep
        };

        let immSteps = newCardsFF && (!__CONTACT_CENTER__ || isPrintOfficeMode()) ? immHireCardPremiumPack.get('newSteps') : immHireCardPremiumPack.get('steps');
        const visibleStep = immHireCardPremiumPack.get('visibleStep')
        immSteps = immSteps.map((step, index) => {
            if (index < visibleStep) {
                return step.set('valid', true);
            }
            return step;
        });

        const showPreLeaveModal = this.isReady();
        const sendMailParams = {
            type: CREDIT_CARD_TYPE_PACK,
            subType: CREDIT_CARD_SUBTYPE_PREMIUM,
            standar: PREMIUM_PACK_STANDARD
        };
        const immShippingAddress = immShippingAddressList.get('shippingAddress');
        const hasShippingAddress = true;
        const nextButtonDisabledStep2 = immHireCardImageSelector.get('isFetching') || immHireCardNameSelector.get('isFetching');
        let isCollectiveEnabledForPremiumPack = !!immCollectivesCardContent.get(PREMIUM_PACK_HIRING);
        const gestorCrossEnabled = immFlagBasedFeatures.get('web-gc-enabled');
        if (gestorCrossEnabled) {
            const immProductBanners = immHiringProductBanners.get('productBanners') || [];
            const premiumPackWafer = immProductBanners.find((banner) => {
                return banner.get('alias') === PREMIUM_PACK_PRODUCT_ALIAS
            });
            isCollectiveEnabledForPremiumPack = premiumPackWafer && premiumPackWafer.get('isCollectiveProduct') && immFlagBasedFeatures.get('collectivos-enabled');
        }
        let collectiveTagData = getCollectiveTagDetails(immTopbar, immProfile);
        const showIneAndRevolving = immFlagBasedFeatures.get(CREDIT_CARD_REVOLVING_PROCESS);
        const agreeIneCheckbox = immHireCardPremiumPack.get('agreeIneCheckbox')
        const checkButtonRadio = immHireCardPremiumPack.get('checkButtonRadio')

        const productName = this.getProcessDetail();
        const tealiumData = [
            catalogue[analyticsId.PREMIUM_PACK_CARD_STEP_1_VIEW]({ productName }),
            catalogue[analyticsId.PREMIUM_PACK_CARD_STEP_2_VIEW]({ productName }),
            catalogue[analyticsId.PREMIUM_PACK_CARD_STEP_3_VIEW]({ productName }),
            catalogue[analyticsId.PREMIUM_PACK_CARD_STEP_4_VIEW]({ productName }),
            catalogue[analyticsId.PREMIUM_PACK_CARD_STEP_5_VIEW]({ productName }),
        ];

        const isShippingAddressButtonDisabled = !!immShippingAddressList && !immShippingAddressList.get('shippingAddressType') && immFlagBasedFeatures.get(ES_COUNTRY);
        const checkboxChecked = immHireCardPremiumPack.get('agreeIneCheckbox')
        const newFinalButtonDisabledCC = newCardsFF && checkboxChecked

        const commonSteps = [
            <WizardStep
                cancelButton
                position="first"
            >
                <WebappRender>
                    <HireCardPremiumPackStep1
                        contractName="premium-pack"
                        flagBasedFeatures={immFlagBasedFeatures}
                        gestorCrossEnabled={gestorCrossEnabled}
                        handleAgreementCheckboxChange={handleAgreementCheckboxChange}
                        immHireCardPremiumPack={immHireCardPremiumPack}
                        immHireInformation={immHireInformation}
                        immProfileFields={immProfile}
                        requestPDFMerge={requestPDFMerge}
                        sendMailParams={sendMailParams}
                        setTermsAndCondsText={setTermsAndCondsText}
                        showIneAndRevolving={showIneAndRevolving}
                    />
                </WebappRender>
                 <ContactCenterRender>
                    <HireCardPremiumPackStep1
                        flagBasedFeatures={immFlagBasedFeatures}
                        gestorCrossEnabled={gestorCrossEnabled}
                        contractName="visa-open"
                        handleAgreementCheckboxChange={handleAgreementCheckboxChange}
                        hireCmsKey="visaopen"
                        immHireCardPremiumPack={immHireCardPremiumPack}
                        immHireInformation={immHireInformation}
                        immProfileFields={immProfile}
                        requestPDFMerge={requestPDFMerge}
                        sendMailParams={sendMailParams}
                        setTermsAndCondsText={setTermsAndCondsText}
                        showIneAndRevolving={showIneAndRevolving}
                    />
                </ContactCenterRender>
            </WizardStep>,
            <WizardStep
                cancelButton={true}
                nextButtonDisabled={nextButtonDisabledStep2}
                onBackClick={false}
                position="middle"
            >
                <HireCardPremiumPackStep2
                    extraImage={EXTRA_IMAGE}
                    immFlagBasedFeatures={immFlagBasedFeatures}
                    immHireCardImageSelector={immHireCardImageSelector}
                    immHireCardNameSelector={immHireCardNameSelector}
                />
            </WizardStep>,
            <WizardStep
                cancelButton={true}
                nextButtonDisabled={immHireCreditLimit.get('isFetching') || immRevolvingPersistentData.get('isIframeError')}
                onBackClick={false}
                position="middle"
            >
                <HireCardPremiumPackStep3
                    handleAccountChange={handleAccountChange}
                    immAccounts={immAccounts}
                    immFlagBasedFeatures={immFlagBasedFeatures}
                    immGlobalVariables={immGlobalVariables}
                    immHireCardImageSelector={immHireCardImageSelector}
                    immHireCardPremiumPack={immHireCardPremiumPack}
                    immHireCreditLimit={immHireCreditLimit}
                    immHirePaymentMethod={immHirePaymentMethod}
                    isInactiveAccountsEnabled={immFlagBasedFeatures.get(WEB_INACTIVE_ACCOUNT_ENABLED)}
                    setAllAccountsToInactive={setAllAccountsToInactive}
                    setHireCreditLimit={setHireCreditLimit}
                    toggleCreditLimitModal={toggleCreditLimitModal}
                    validate={validate}
                />
            </WizardStep>,
            <WizardStep
                cancelButton={true}
                onBackClick={false}
                position="middle"
                nextButtonDisabled={isShippingAddressButtonDisabled}
            >
                <HireCardPremiumPackStep4
                    immHireContactData={immHireContactData}
                    immShippingAddressList={immShippingAddressList}
                    setShippingAddress={setShippingAddress}
                    getInitCardsDocuments={getInitCardsDocuments}
                    newCardsFF={newCardsFF}
                />
            </WizardStep>,
            <WizardStep
                addLoadingBehaviour
                cancelButton={true}
                immFinalButton={'hireCardPremiumPack-hire'}
                isLoading={immHireCardPremiumPack.get('isFetching')}
                onBackClick={false}
                position="last"
                officeSignature={newCardsFF && isPrintOfficeMode()}
                finalButtonDisabled={newCardsFF ? (newFinalButtonDisabledCC ? false : true) : null}
            >
                <HireCardPremiumPackStep5
                    contractName="premium-pack"
                    immHireCardImageSelector={immHireCardImageSelector}
                    immHireCardNameSelector={immHireCardNameSelector}
                    immHireCardPremiumPack={immHireCardPremiumPack}
                    immHireCreditLimit={immHireCreditLimit}
                    immHirePaymentMethod={immHirePaymentMethod}
                    immProfile={immProfile}
                    immPdfData={immPdfData}
                    immShippingAddress={immShippingAddressList.get('shippingAddress')}
                    handleAgreementCheckboxChange={handleAgreementCheckboxChange}
                    operativeName={__CONTACT_CENTER__ ? "operatives-cardHire_visaOpenNew" : undefined}
                    sendMailParams={sendMailParams}
                    immFlagBasedFeatures={immFlagBasedFeatures}
                    sendPrecontractualDocumentMail={sendPrecontractualDocumentMail}
                    setTermsAndCondsText={setTermsAndCondsText}
                    showIneAndRevolving={showIneAndRevolving}
                    onHandleChangeCheckBoxCC={onHandleChangeCheckBoxCC}
                    hireCardPremiumPackprintDocument={hireCardPremiumPackprintDocument}
                    cardsConfimationScrollDownPolicy={cardsConfimationScrollDownPolicy}
                    hireCardPremiumPackprintDocumentPolicy={hireCardPremiumPackprintDocumentPolicy}
                    printedAndSignedRadioChanged={printedAndSignedRadioChanged}
                    enableButtonOffice={enableButtonOffice}
                    checkRadioButtonPolicy={checkRadioButtonPolicy}
                    documentsPrintedAndSigned={documentsPrintedAndSigned}
                    processEmail={processEmail}
                />
            </WizardStep>
        ];

        const newSteps = newCardsFF && (__CONTACT_CENTER__ && isPrintOfficeMode() || !__CONTACT_CENTER__) ? [
            ...commonSteps.slice(0, 4),
            <WizardStep
                cancelButton={true}
                onBackClick={false}
                position="middle"
                nextButtonDisabled={isPrintOfficeMode() ? !checkButtonRadio : !agreeIneCheckbox}
                immFlagBasedFeatures={immFlagBasedFeatures}
            >
                {this.buildINE()}
            </WizardStep>,
            ...commonSteps.slice(4)
        ] : commonSteps;
      
        return (
            <div>
                <div className="col-xs-12 col-md-8">
                    <Wizard
                        actions={wizardActions}
                        immSteps={immSteps}
                        showPreLeaveModal={showPreLeaveModal}
                        stepsAmount={immSteps.size}
                        tealium={tealiumData[immHireCardPremiumPack.get('visibleStep') - 1]}
                        visibleStep={immHireCardPremiumPack.get('visibleStep')}
                        wizardClass="hire-card-premium-pack__wizard"
                        isTaggingSecondVersion
                    >
                        {newSteps} 
                    </Wizard>

                </div>
                <div className="col-xs-12 col-md-4">
                    <div className="row">
                        <div className="col-xs-6 col-md-12 grid-view--variable-cell-separation">
                            <HireCardSidebar
                                collectiveEnabled={isCollectiveEnabledForPremiumPack}
                                collectiveTagData={collectiveTagData}
                                creditType="premium"
                                extraImage={EXTRA_IMAGE}
                                immAccounts={immAccounts}
                                immAddress={immShippingAddress}
                                immGlobalVariables={immGlobalVariables}
                                immHireCardImageSelector={immHireCardImageSelector}
                                immHireCardNameSelector={immHireCardNameSelector}
                                immHireCreditLimit={immHireCreditLimit}
                                immHirePaymentMethod={immHirePaymentMethod}
                                immShippingAddressList={immShippingAddressList}
                                immProfile={immProfile}
                                hasShippingAddress={hasShippingAddress}
                                selectedAccount={immSteps.getIn([THIRD_STEP, 'accountId'])}
                            />
                        </div>
                        <div className="col-xs-6 col-md-12 grid-view--fix-cell-separation">
                            <CallMeBack context="contracts" modifier="contracts-view" pageTitle={formatText('breadcrumb-cards')} hasEntrance={false} />
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        const {
            immHireCardPremiumPack,
            immAccounts,
            immCards,
            immFlagBasedFeatures,
            immProfile,
        } = this.props;
        const pageTitle = getFinalTitle('hireCardPremiumPack-pageTitle');
        let hasAvailableAccounts = true;
        if (__CONTACT_CENTER__) {
            hasAvailableAccounts = ownerFromAccount(immAccounts);
        }
        const mappingBreadcrumb = [
            {
                text: formatText('breadcrumb-cards'),
                url: '/myprofile/cards'
            },
            {
                text: formatText("hireCardPremiumPack-breadcrumb")
            }
        ];

        const hasAvailableCreditCards = isAvailableHireCreditCards(immCards);
        const isSecondStep = immHireCardPremiumPack.get('visibleStep') == WIZARD_SECOND_STEP;
        const isNerudaUser = immProfile.get('isNerudaUser');
        const creditCardsLimitExceed = immFlagBasedFeatures.get(LIMIT_CREDIT_CARD) && !isNerudaUser && !hasAvailableCreditCards && isSecondStep;
        const processDetail = this.getProcessDetail();
        const hireRestrictionFlag = immHireCardPremiumPack.getIn(['steps', WIZARD_FIRST_STEP-1, 'hireRestriction']);
        const hireRestrictionFF = immFlagBasedFeatures.get(MESSAGE_HIRE_24H);

        let content;

        if (immHireCardPremiumPack.get('error')
            || (__CONTACT_CENTER__ && !hasAvailableAccounts)
            || creditCardsLimitExceed) {
            content = (
                <div className="col-xs-12 col-md-offset-1 col-md-10">
                    <HireCarPremiumPackError
                        immHireCardPremiumPack={immHireCardPremiumPack}
                        hasAvailableAccounts={__CONTACT_CENTER__ ? hasAvailableAccounts : undefined}
                        processDetail={processDetail}
                        maxAllowedNumberCards={creditCardsLimitExceed}
                    />
                </div>
            );
        } else if (hireRestrictionFlag && hireRestrictionFF) {
        content = (
            <div className="col-xs-12 col-md-offset-1 col-md-10">
                <HireCarPremiumPackError
                    immHireCardPremiumPack={immHireCardPremiumPack}
                    hasAvailableAccounts={__CONTACT_CENTER__ ? hasAvailableAccounts : undefined}
                    processDetail={processDetail}
                    maxAllowedNumberCards={creditCardsLimitExceed}
                    hireRestrictionFlag={hireRestrictionFlag}
                />
            </div>
        );
    } else if (immHireCardPremiumPack.get('submitSuccessful')) {
            content = this.buildSuccessful();
        } else {
            content = this.buildWizardHiringSteps();
        }

        return (
            <div className="hire-card-premium-pack">
                <div className="container-fluid">
                    <div className="row">
                        <OKCover size="medium" section="pg" customClass="col-xs-12">
                            <OKHeaderSubPage
                                breadcrumbConfig={mappingBreadcrumb}
                                finalTitle={pageTitle}
                            />
                        </OKCover>
                    </div>
                </div>
                <div className="grid-view__body">
                    <div className="container-fluid">
                        <div className="row grid-view--content-position-negative">
                            {content}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

HireCardPremiumPackView.propTypes = {
    getshippingAddressList: PropTypes.func.isRequired,
    getBlockedAccounts: PropTypes.func,
    handleAccountChange: PropTypes.func.isRequired,
    handleAgreementCheckboxChange: PropTypes.func.isRequired,
    hireCardPremiumPack: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immCards: PropTypes.object.isRequired,
    immCollectivesCardContent: PropTypes.object.isRequired,
    immFlagBasedFeatures: PropTypes.object.isRequired,
    immGlobalVariables: PropTypes.object.isRequired,
    immHireCardImageSelector: PropTypes.object.isRequired,
    immHireCardNameSelector: PropTypes.object.isRequired,
    immHireCardPremiumPack: PropTypes.object.isRequired,
    immHireContactData: PropTypes.object.isRequired,
    immHireCreditLimit: PropTypes.object.isRequired,
    immHireInformation: PropTypes.object.isRequired,
    immHirePaymentMethod: PropTypes.object.isRequired,
    immHiringProductBanners: PropTypes.object,
    immPdfData: PropTypes.object.isRequired,
    immProfile: PropTypes.object.isRequired,
    immShippingAddressList: PropTypes.object,
    immTopbar: PropTypes.object,
    match: PropTypes.object,
    resetPrecontractualDocumentMail: PropTypes.func,
    reset: PropTypes.func.isRequired,
    resetPrecontractualMail: PropTypes.func.isRequired,
    resetTermsAndCondsText: PropTypes.func.isRequired,
    resetBlockedAccounts: PropTypes.func,
    requestPDFMerge: PropTypes.func.isRequired,
    sendPrecontractualDocumentMail: PropTypes.func.isRequired,
    setAllAccountsToInactive: PropTypes.func.isRequired,
    setHireCreditLimit: PropTypes.func.isRequired,
    setShippingAddress: PropTypes.func.isRequired,
    setTermsAndCondsText: PropTypes.func.isRequired,
    setVisibleStep: PropTypes.func.isRequired,
    setWillCancel: PropTypes.func.isRequired,
    toggleCreditLimitModal: PropTypes.func.isRequired,
    validate: PropTypes.func.isRequired,
    validateStep: PropTypes.func.isRequired,
    immRevolvingPersistentData: PropTypes.object,
};

module.exports.constructor = HireCardPremiumPackView;
module.exports.HireCardPremiumPackView = connect(
    state => ({
        immAccounts: state.accounts,
        immCards: state.cards,
        immCollectivesCardContent: state.collectivesCardContent,
        immFlagBasedFeatures: state.flagBasedFeatures,
        immGlobalVariables: state.globalVariables,
        immHireCardImageSelector: state.hireCardImageSelector,
        immHireCardNameSelector: state.hireCardNameSelector,
        immHireCardPremiumPack: state.hireCardPremiumPack,
        immHireContactData: state.hireContactData,
        immHireCreditLimit: state.hireCreditLimit,
        immHireInformation: state.hireInformation,
        immHirePaymentMethod: state.hirePaymentMethod,
        immHiringProductBanners: state.hiringProductBanners,
        immPdfData: state.precontractualsMergePdfs,
        immProfile: state.profile,
        immShippingAddressList: state.shippingAddress,
        immTopbar: state.topbar,
        immRevolvingPersistentData: state.revolvingPersistentData,
        immPrinter: state.printer,
    }),
    {
        getshippingAddressList: shippingAddressAction.getShippingAddressList,
        getBlockedAccounts: blockedAccountsAction.getBlockedAccounts,
        handleAccountChange: hireCardPremiumPackActions.setAccount,
        handleAgreementCheckboxChange: hireCardPremiumPackActions.setAgreementCheckbox,
        onHandleChangeCheckBoxCC: hireCardPremiumPackActions.onHandleChangeCheckBoxCC,
        hireCardPremiumPack: hireCardPremiumPackActions.hireCardPremiumPack,
        reset: hireCardPremiumPackActions.reset,
        resetTermsAndCondsText: termsAndCondsInfoActions.reset,
        requestPDFMerge: mergePreContractualsPDF.requestPDFMerge,
        resetPrecontractualMail: preContractualMailActions.resetPrecontractualMail,
        resetBlockedAccounts: blockedAccountsAction.resetBlockedAccounts,
        resetPrecontractualDocumentMail: precontractualDocumentMailAction.resetPrecontractualDocumentMail,
        setAllAccountsToInactive: hireCardPremiumPackActions.setAllAccountsToInactive,
        setHireCreditLimit: hireCreditLimitActions.setHireCreditLimit,
        setShippingAddress: shippingAddressAction.setShippingAddress,
        setTermsAndCondsText: termsAndCondsInfoActions.setTermsAndCondsText,
        setVisibleStep: hireCardPremiumPackActions.setVisibleStep,
        setWillCancel: hireCardPremiumPackActions.setWillCancel,
        sendPrecontractualDocumentMail: precontractualDocumentMailAction.sendPrecontractualDocumentMail,
        toggleCreditLimitModal: hireCreditLimitActions.toggleModal,
        validate: hireCardPremiumPackActions.validate,
        validateStep: hireCardPremiumPackActions.validateStep,
        cardsConfimationScrollDown: hireCardCreditINEActions.cardsConfimationScrollDown,
        cardsConfimationScrollDownPolicy: hireCardCreditINEActions.cardsConfimationScrollDownPolicy,
        checkCheckedDocument: hireCardCreditINEActions.checkCheckedDocument,
        printedAndSignedRadioChanged: printedActions.printedAndSignedRadioChanged,
        enableButtonOffice: mortgageRequestHolderConfirmation.enableButtonOffice,
        checkRadioButton: hireCardPremiumPackActions.checkRadioButton,
        checkRadioButtonPolicy: hireCardPremiumPackActions.checkRadioButtonPolicy,
        hireCardPremiumPackprintDocument: hireCardPremiumPackActions.printDocument,
        hireCardPremiumPackprintDocumentPolicy: hireCardPremiumPackActions.printDocumentPolicy,
        myCardsTarjetasHire: hireCardPremiumPackActions.myCardsTarjetasHire,
        getInitCardsDocuments: hireCardCreditINEActions.getInitCardsDocuments,
        hireCardOpenCreditprintDocument: hireCardPremiumPackActions.printDocument,
        processEmail: hireCardPremiumPackActions.processEmail,


    }
)(withRouter(HireCardPremiumPackView));
